import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivityInterface, WorkflowStepInterface } from '@vendasta/automata';
import { Observable, of } from 'rxjs';
import { ActivityTableEntry, AutomationDisplayService, NodeData } from '../../common/automation-display.service';
import { AutomationsRouterService } from '../../../../shared/automations-router.service';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GetOrderDataService extends AutomationDisplayService {
  constructor(
    protected readonly translateService: TranslateService,
    private readonly router: AutomationsRouterService,
  ) {
    super();
  }

  /** Gets text for the activity column in the table. */
  getActivityColumn(_namespace: string, activity: ActivityInterface): ActivityTableEntry {
    // Check for problems creating the tag.
    const activityData = activity?.activityData ? JSON.parse(activity.activityData) : {};

    return this.tableEntry(
      this.router
        .applyRoutePrefix(
          `/order-management/${activityData?.order_details?.account_group_id}/info/${activityData?.order_details?.order_id}`,
        )
        .pipe(
          take(1),
          map((linkToOrder) =>
            this.translateService.instant('AUTOMATIONS.EDITOR.TASKS.GET_ORDER_DATA.ACTIVITY.TITLE', {
              orderUrl: linkToOrder,
              orderId: activityData?.order_details?.order_id,
            }),
          ),
        ),
      of(''),
    );
  }

  /** The text in an automation node (i.e. the nodes in the graph). */
  getAutomationNodeData(
    _namespace: string,
    _step: WorkflowStepInterface,
    _isWaitUntilNode: boolean,
  ): Observable<NodeData> {
    return this.nodeDisplayData(
      this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.GET_ORDER_DATA.TITLE'),
      this.noValidationErrorsDetected(),
    );
  }
}
